import { Navigate, useLocation } from "react-router-dom";
import storage from "../../helpers/storage";
import { useAuthStore } from "../../redux/auth-store";
import { logRedirect } from "../../utils/performance";
import { DEFAULT_AUTH_HOME } from "../../constants/routes";

/** Public routes only — redirects away if a session already exists. */
const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { token } = useAuthStore();
  const authToken = storage.getToken() || token;

  if (authToken) {
    const from =
      (location.state as { from?: { pathname?: string } })?.from?.pathname ||
      DEFAULT_AUTH_HOME;
    logRedirect("AuthGuard", from, "already_authenticated");
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
